import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "anticon"
}



export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenu',
  props: {
  menuInfo:{
    type: Object,
    default:()=>({}),
  },
  collapsed:Boolean,
},
  setup(__props) {



const setMenu = (item: { meta: { type: string; }; path: string; }) => {
  if (item.meta.type) {
    return item.path + "?type=" + item.meta.type;
  }
  return item.path;
}



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_sub_menu = _resolveComponent("sub-menu", true)!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (_openBlock(), _createBlock(_component_a_sub_menu, _mergeProps({
    key: __props.menuInfo.path
  }, _ctx.$props), {
    title: _withCtx(() => [
      (__props.menuInfo.meta.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$antIcons[__props.menuInfo.meta.icon])))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(__props.menuInfo.meta.title), 1)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuInfo.children, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!item.children && !item.meta.hidden)
            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                key: item.path
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: setMenu(item)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 2
              }, 1024))
            : (item.children)
              ? (_openBlock(), _createBlock(_component_sub_menu, {
                  key: item.path,
                  "menu-info": item,
                  collapsed: __props.collapsed
                }, null, 8, ["menu-info", "collapsed"]))
              : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _: 1
  }, 16))
}
}

})